import { render, staticRenderFns } from "./TaskFilesSection.vue?vue&type=template&id=b3f2b316&scoped=true"
import script from "./TaskFilesSection.vue?vue&type=script&lang=js"
export * from "./TaskFilesSection.vue?vue&type=script&lang=js"
import style0 from "./TaskFilesSection.vue?vue&type=style&index=0&id=b3f2b316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f2b316",
  null
  
)

export default component.exports